import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class ScheduleTimeService extends ServiceCRUD {
  constructor() {
    super(`/api/schedule-time`);
  }
}

export default new ScheduleTimeService();
